import { useAccess } from '@/hooks/use-access.ts'
import { cn } from '@/utils/index.ts'
import { CUSTOMER_DOCUMENT_SECTIONS } from './const/sections.ts'
import type { ScopedCustomerDocumentsSearch } from './search.ts'

export function CustomerDocumentsNavigation({
  kind,
  canReadOrders,
  canReadBills,
  onChange
}: {
  kind: ScopedCustomerDocumentsSearch['kind']
  canReadOrders: boolean
  canReadBills: boolean
  onChange: (kind: ScopedCustomerDocumentsSearch['kind']) => void
}) {
  const access = useAccess()
  const permissions = {
    rental: 'order.rental.read',
    service: 'order.service.read',
    bills: 'bill.read',
    groups: 'bill.group.read'
  } as const
  return (
    <nav
      aria-label="客户单据分类"
      className="bg-surface flex flex-wrap gap-2 rounded-xl p-3 lg:sticky lg:top-24 lg:flex-col"
    >
      {CUSTOMER_DOCUMENT_SECTIONS.filter(
        (section) =>
          access.can(permissions[section.key]) && (section.permission === 'order' ? canReadOrders : canReadBills)
      ).map(({ key, label, Icon }) => (
        <button
          key={key}
          type="button"
          aria-current={kind === key ? 'page' : undefined}
          onClick={() => onChange(key)}
          className={cn(
            'flex flex-1 cursor-pointer items-center gap-2 rounded-lg border-0 px-3 py-3 text-left text-sm',
            kind === key ? 'bg-accent/10 text-accent font-medium' : 'bg-surface text-content hover:bg-surface-muted'
          )}
        >
          <Icon aria-hidden size={18} />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  )
}
